import { buttonVariants } from '@/components/ui/button';
import { useSessao } from '@/lib/auth';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import ErrorPageShell from '../error-page-shell';

export default function NotFoundPage() {
  const { t } = useTranslation('common');
  const { data: usuario } = useSessao();
  const route = usuario ? '/dashboard' : '/login';

  return (
    <ErrorPageShell
      title={<span className="text-4xl">{t($ => $.pageNotFound.title)}</span>}
      message={t($ => $.pageNotFound.message)}
      button={
        <Link
          to={route}
          className={buttonVariants({
            className: 'mt-3',
          })}
        >
          {t($ => $.pageNotFound.backHome)}
        </Link>
      }
    />
  );
}
